module.exports = __webpack_public_path__ + "static/13-b5d529de4d476d778f544ccbb341168f.jpg";